import { VerificationSource } from "../../const/user.mjs";
import { z } from "zod";
//#region src/api/orpc/userBase.ts
const membershipSchema = z.object({
	membershipId: z.string(),
	tier: z.number().int().nullable()
});
const decorationTypeSchema = z.enum([
	"BADGE",
	"AVATAR_FRAME",
	"ARTWORK_FRAME",
	"LIVE_BANNER"
]);
const decorationSchema = z.object({
	id: z.string(),
	code: z.string(),
	type: decorationTypeSchema,
	description: z.string().nullable(),
	data: z.unknown().nullable(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
	allowUserEditRemark: z.boolean().nullable()
});
const activeDecorationSchema = z.object({
	id: z.string(),
	decorationId: z.string(),
	decoration: decorationSchema,
	isEnabled: z.boolean(),
	obtainedAt: z.iso.datetime(),
	obtainedFrom: z.string(),
	updatedAt: z.iso.datetime(),
	createdAt: z.iso.datetime(),
	userId: z.string(),
	userRemark: z.string().nullable()
});
const verificationSourceSchema = z.enum(Object.values(VerificationSource));
const userSchema = z.object({
	id: z.string(),
	email: z.string().nullish(),
	emailVerified: z.boolean().optional(),
	username: z.string(),
	displayName: z.string(),
	avatarMediaId: z.string(),
	createdAt: z.date(),
	updatedAt: z.date(),
	verificationSource: verificationSourceSchema.nullish(),
	isAdmin: z.boolean().optional()
});
//#endregion
export { activeDecorationSchema, decorationSchema, decorationTypeSchema, membershipSchema, userSchema, verificationSourceSchema };
